import type { ReactNode } from "react";

export type SectionItem<T extends string> = { id: T; label: string; icon?: ReactNode };

export default function SectionNav<T extends string>({ label, items, value, onChange, compact = false }: {
  label: string; items: SectionItem<T>[]; value: T; onChange: (value: T) => void; compact?: boolean;
}) {
  return <nav className={`section-tabs${compact ? " compact-tabs" : ""}`} aria-label={label}>
    {items.map((item) => <button type="button" key={item.id} aria-current={value === item.id ? "page" : undefined}
      className={value === item.id ? "active" : ""} onClick={() => onChange(item.id)}>{item.icon && <span aria-hidden="true">{item.icon}</span>}{item.label}</button>)}
  </nav>;
}
